import { AwsFilesContext } from ".";
import { useGenericContext } from "../../hooks";

export const useAwsFiles = () => useGenericContext(AwsFilesContext);
